;(function ($) {
    var pluginName = 'rkasTable';
    var defaults = {
        wrapperClass: "table-wrapper",
        scrollerClass: "table-wrapper--scroller",
        prevClass: "table-button--prev",
        nextClass: "table-button--next",
        intervalSpeed: 30,
        scrollDistance: 10,
        offset: 100
    };
    var initSelector = '.js-responsiveTable';

    //hack to add classes from data attribute (requested by BE)
    var tablesWithDataClass = document.querySelectorAll('[data-tableclass]');
    for (var i = 0; i < tablesWithDataClass.length; i++) {
        var dataClasses = tablesWithDataClass[i].dataset.tableclass;
        if (dataClasses) {
            if (tablesWithDataClass[i].className.length) {
                tablesWithDataClass[i].className += " " + dataClasses
            } else {
                tablesWithDataClass[i].className +=  dataClasses
            }
        }
    }

    /**
     * Table
     * @class
     * @param {jQuery} $elements Elements in the group
     * @param {Object} options   An option map
     */
    function Table(element, options) {

        this.$table = $(element);
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.resizeTimer = 0;
        this.scrollWith = this.$table.data("scrollWidth") ? this.$table.data("scrollWidth") : this.$table.width;

        this.$btnPrev = $('<div class="table-button ' + this.options.prevClass + '">' + rkas.icon.render('#arrow-left') + '</div>');
        this.$btnNext = $('<div class="table-button ' + this.options.nextClass + '">' + rkas.icon.render('#arrow-right') + '</div>');

        this.init();
    }

    Table.prototype.init = function () {
        //add wrapper
        this.$table.wrap("<div class='" + this.options.wrapperClass + "'>");
        this.$wraper = this.$table.parent();

        this.$table.wrap("<div class='" + this.options.scrollerClass + "' tabindex='0'>");
        this.$scroller = this.$table.parent();

        //add controls
        this.$wraper.append(this.$btnNext);
        this.$wraper.append(this.$btnPrev);

        this.collsCount = this.$table.find("tr").get(1).children.length;

        if (this.collsCount > 5) {
            if (this.$table.data("width") == "full") {
                this.$wraper.addClass("table-wrapper--fullwidth");
            } else {
                this.$wraper.addClass("table-wrapper--content-width");
            }
        }

        this.$scroller.on("scroll.rkas.table", this.bindScroll.bind(this)).trigger("scroll");

        this.$btnPrev.on("mousedown.rkas.table", this.bindMouseDown.bind(this, true));
        this.$btnPrev.on("mouseup.rkas.table", this.bindMouseUp.bind(this));
        this.$btnNext.on("mousedown.rkas.table", this.bindMouseDown.bind(this, false));
        this.$btnNext.on("mouseup.rkas.table", this.bindMouseUp.bind(this));

        $(window).on('scroll.rkas.table', this.scrollHandler.bind(this));
        $(window).on('resize.rkas.table', this.resizeHandler.bind(this));
    };

    Table.prototype.bindMouseDown = function (reverse) {
        var that = this;
        var scrollStep = this.options.scrollDistance;

        reverse ? scrollStep = scrollStep * (-1) : void 0;

        this.scrollTable(scrollStep);

        this.scrollInterval = setInterval(function () {
            that.scrollTable(scrollStep);

            if (that.$scroller.scrollLeft() == that.$scroller[0].scrollWidth - that.$scroller.width()
                || that.$scroller.scrollLeft() == 0
            ) {
                clearInterval(that.scrollInterval)
            }
        }, this.options.intervalSpeed);

    };

    Table.prototype.bindMouseUp = function () {
        clearInterval(this.scrollInterval);
    };

    Table.prototype.bindScroll = function () {
        var left = this.$scroller.scrollLeft();
        left <= 0 ? this.$wraper.removeClass("scrollPrev") : this.$wraper.addClass("scrollPrev");

        var mainWidth = this.$wraper.width();
        var tableWidth = this.$table.width();

        if (Math.ceil(mainWidth + left) >= tableWidth || mainWidth === 0) {
            this.$wraper.removeClass("scrollNext");
            this.bindMouseUp();
        } else {
            this.$wraper.addClass("scrollNext");
        }

    };

    Table.prototype.scrollTable = function (distance) {
        var left = this.$scroller.scrollLeft() + distance;
        this.$scroller.scrollLeft(left);
    };

    Table.prototype.scrollHandler = function () {

        var el = this.$table;
        var scrollPos = window.pageYOffset;
        var tableHeight = el.height();
        var tableTop = el.offset().top;
        var tts = tableTop - scrollPos;
        var tbs = tts +tableHeight;
        var wHeight = window.innerHeight;
        var fixPos = Math.ceil( wHeight / 2 );
        var fixed = false;

        if( (!fixed && tts  < fixPos) && (!fixed && tbs > fixPos) ){
            this.$btnNext.css("top", scrollPos - tableTop + fixPos);
            this.$btnPrev.css("top", scrollPos - tableTop + fixPos);
        }

        if ( (tbs > fixPos) && (tts < fixPos) ){
            fixed = true;
        }

        if (tts > fixPos){
            this.$btnNext.css("top", "70px");
            this.$btnPrev.css("top", "70px");
        }

        if (tbs < fixPos){
            this.$btnNext.css({"top":"auto","bottom":"20px"});
            this.$btnPrev.css({"top":"auto","bottom":"20px"});
        } else {
            this.$btnNext.css({"bottom":"auto"});
            this.$btnPrev.css({"bottom":"auto"});
        }

    };

    /**
     * Delay the resize method to make sure resizing has finished.
     * @method resizeHandler
     * @returns {void}
     */
    Table.prototype.resizeHandler = function () {
        this.$table.width > this.$wraper.width ? this.$wraper.addClass("scrollPrev scrollNext") : this.$wraper.addClass("scrollPrev scrollNext");
        this.$scroller.trigger("scroll.rkas.table");
    };

    /**
     * Check if current instance is in target and set new heights if true.
     * @method refreshHandler
     * @param   {Event} event  An event object
     * @param   {HTMLElement} target Containing HTML element
     * @returns {void}
     */
    Table.prototype.refreshHandler = function (event, target) {
        var contains = false;

        // loop through all elements to see if any of them is inside target
        this.$table.each(function () {
            if ($.contains(target, this)) {
                contains = true;
            }
        });

        if (target && contains) {
            this.setHeights();
        }
    };

    /**
     * Set equal heights to all elements in the group.
     * @method setHeights
     * @returns {void}
     */
    Table.prototype.setHeights = function () {
        var currentTallest = 0;
        var currentRowStart = 0;
        var rowDivs = [];
        var $el;
        var topPosition = 0;

        this.$table.each(function () {
            $el = $(this);
            $el.css({
                'min-height': '0'
            });
            topPosition = $el.offset().top;
            if (currentRowStart != topPosition) {
                for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].css({
                        'min-height': currentTallest
                    });
                }
                rowDivs.length = 0;
                currentRowStart = topPosition;
                currentTallest = $el.height() + 1;
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height() + 1) : (currentTallest);
            }
            if (rowDivs.length > 1) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].css({
                        'min-height': currentTallest
                    });
                }
            }
        });
    };

    /**
     * Destroy the plugin instance
     * @method destroy
     * @returns {void}
     */
    Table.prototype.destroy = function () {
        $(window).off('resize.rkas.table');

        this.$table.css('min-height', '');
        $(this.$table[0]).removeData('plugin_' + pluginName);
    };

    /**
     * Create jQuery plugin.
     * @param {Object} options Extended options
     * @listens rkas.table
     * @returns {Array<Table>} Array of Tables
     */
    $.fn[pluginName] = function (options) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var instance = $.data(this, 'plugin_' + pluginName);

            if (!instance) {
                if (options === 'destroy') {
                    return;
                }

                $.data(this, 'plugin_' + pluginName, new Table(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }
        });
    };

    /**
     * @event enhance.rkas.table
     * @param   {Event} event
     */
    $(document).on('enhance.rkas.table', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]();
    });

    /**
     * @event destroy.rkas.table
     * @param   {Event} event
     */
    $(document).on('destroy.rkas.links', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]('destroy');
    });

    /**
     * Auto-init the plugin on DOM ready.
     * @fires enhance.rkas.table
     */
    $(function () {
        $(document).trigger('enhance.rkas.table');
    });
}(jQuery));
